import { render } from "./SortCalendarAscending.vue?vue&type=template&id=266b87cd"
import script from "./SortCalendarAscending.vue?vue&type=script&lang=js"
export * from "./SortCalendarAscending.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__